<template>
    <div class="wrap">
        <div class="container" style="height: 100%;">
            <!-- 购物袋标题和删除按钮 -->
            <div class="cart-header">
                <div class="cart-title">购物袋 ({{cart_list.length}})</div>
                <!-- <van-icon 
                    name="delete" 
                    color="#000000" 
                    size="20" 
                    @click="del(value.id,index)" 
                /> -->
                <div class="close-btn" @click="$router.back()">×</div>
            </div>

            <div class="carts" :class="goods_checkbox.length>2?'carts':'cartsnone'">
                <van-checkbox-group v-model="goods_checkbox" ref="checkboxGroup">
                    <div class="cart-item" v-for="(value,index) in cart_list" :key="index">
                        <!-- 商品信息 -->
                        <div class="cart-item-content">
                            <!-- 选择框和图片容器 -->
                            <div class="cart-item-left">
                                <van-checkbox 
                                    icon-size="20px" 
                                    checked-color="#000000" 
                                    :name="value.id" 
                                    :disabled="value.is_error == 1"
                                    @click="checkBoxClick"
                                />
                                <div class="cart-item-img">
                                    <img :src="value.images" :alt="value.title">
                                </div>
                            </div>
                            
                            <!-- 商品详情 -->
                            <div class="cart-item-info">
                                <div style="display: flex; justify-content: center;">
                                    <div class="cart-item-title">{{value.title}}</div>
                                    <div class="close-btn" style="font-size: 30px;" @click="del(value,value.id,index)">×</div>
                                </div>
                                <div class="cart-item-spec">
                                    <span class="spec-item" v-for="(spec,idx) in value.spec" :key="idx">
                                        {{spec.value}}
                                    </span>
                                </div>
                                
                                <!-- 商品价格和数量 -->
                                <div class="cart-item-bottom">
                                    <div class="cart-item-price">
                                        <span class="current-price">¥ {{Number(value.price*value.stock).toFixed(2)}}</span>
                                        <!-- <span class="original-price">¥{{Number(value.original_price*value.stock).toFixed(2)}}</span> -->
                                    </div>
                                    <van-stepper 
                                        class="cart-item-stepper"
                                        @change="stock($event,value.id,value.goods_id,index)" 
                                        input-width="30px" 
                                        button-size="22px" 
                                        :default-value="value.stock" 
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </van-checkbox-group>
                
                <van-empty 
                    v-if="cart_list.length <= 0"
                    class="cart-empty" 
                    description="购物袋是空的..." 
                />
            </div>

            <!-- 底部结算栏 -->
            <div class="cart-footer">
                <!-- 上部分：全选、删除和价格信息 -->
                <div class="cart-footer-top">
                    <div class="left-controls">
                        <van-checkbox 
                            v-model="select_all" 
                            @click="toggleAll"
                            icon-size="18px" 
                            checked-color="#000000" 
                            :disabled="cart_list.length <= 0"
                        >
                            全选
                        </van-checkbox>
                        <div class="delete-btn" @click="deleteSelected">删除</div>
                    </div>
                    <div class="price-info">
                        <div class="total-price">¥ {{totalPrice}}</div>
                        <div class="discount-price"><span class="youhui">促销优惠</span> <span class="youhui-price"> -¥{{'0.00'}}</span></div>
                    </div>
                </div>
                
                <!-- 下部分：购买按钮 -->
                <div class="cart-footer-bottom">
                    <van-button 
                        block 
                        type="primary" 
                        @click="to_pay"
                    >
                        立即购买 ({{goods_checkbox.length}})
                    </van-button>
                </div>
            </div>
        </div>
        <v-foot></v-foot>
        <!-- <van-tabbar route active-color="#000000" >
          <van-tabbar-item replace to="/" icon="home-o">首页</van-tabbar-item>
          <van-tabbar-item replace to="/kefu" icon="service-o">客服</van-tabbar-item>
          <van-tabbar-item replace to="/carts" icon="cart-o">购物车</van-tabbar-item>
          <van-tabbar-item replace to="/personal" icon="contact-o">我的</van-tabbar-item>
        </van-tabbar> -->
    </div>
</template>
<script>
    export default {
        components: {},
        beforeRouteEnter(to, from, next) {
            to.meta.issearch = true;
            to.meta.isNav = false;
            next();
        },
        created() {
            if (this.$route.meta) {
                this.$route.meta.issearch = true;
                this.$route.meta.isNav = false;
            }
            
            // 添加埋点接口调用
            this.trackPageView();
            
            // 获取购物车数据
            this.getData();
        },
        data() {
            return {
                goods_checkbox: [],
                goods_number: '1',
                quanxuan: [],
                cart_list: [],
                select_all: true,
                discountPrice: 0, // 优惠金额
            }
        },
        computed: {
            // 计算选中商品的总价
            totalPrice() {
                return this.goods_checkbox.reduce((total, id) => {
                    const item = this.cart_list.find(item => item.id === id);
                    if (item) {
                        return total + (Number(item.price) * item.stock);
                    }
                    return total;
                }, 0).toFixed(2);
            },
            
            // 计算优惠金额
            discountAmount() {
                return this.goods_checkbox.reduce((total, id) => {
                    const item = this.cart_list.find(item => item.id === id);
                    if (item) {
                        const originalPrice = Number(item.original_price) * item.stock;
                        const currentPrice = Number(item.price) * item.stock;
                        return total + (originalPrice - currentPrice);
                    }
                    return total;
                }, 0).toFixed(2);
            }
        },
        watch: {
            // 监听选中商品变化，更新优惠金额
            goods_checkbox: {
                handler() {
                    this.discountPrice = this.discountAmount;
                },
                immediate: true
            }
        },
        methods: {
            // 修改埋点方法，确保参数正确传递
            trackPageView() {
                const url = 'api/agreement/maidian';
                
                // 方法一：使用对象形式传递参数
                // this.GET(url, { type: '购物车' }, (response) => {
                //     console.log('埋点数据上报成功:', response);
                // });
                
                // 如果上面的方法不起作用，尝试方法二：使用URL参数形式
                const fullUrl = `${url}?type=carts`;
                this.GET(fullUrl, null, (response) => {
                    console.log('埋点数据上报成功:', response);
                });
                
                // 如果还不起作用，尝试方法三：使用POST请求
                // this.POST(url, { type: '购物车' }, (response) => {
                //     console.log('埋点数据上报成功:', response);
                // });
            },
            checkBoxClick(e){
                console.log('当前信息',e)
                window.console.log(this.goods_checkbox)
                this.select_all = this.goods_checkbox.length === this.cart_list.length && this.cart_list.length !== 0;
            },
            toggleAll() {
                if(this.select_all){
                    this.$refs.checkboxGroup.toggleAll(false);
                }else {
                    this.$refs.checkboxGroup.toggleAll(true);
                }
            },
            getData(){
                var url = 'api/cart/index';
                var _self = this;
                this.GET(url,function (data) {
                    _self.cart_list = data.data.data;
                    for (var i = 0; i <  _self.cart_list.length; i++){
                        _self.goods_checkbox.push(_self.cart_list[i].id)
                    }
                })
            },
            stock(stock,id,goods_id,index){
                var data = {stock:stock,id:id,goods_id:goods_id}
                var url = 'api/cart/stock';
                var _self = this;
                this.POST(url,data,function (data) {
                    if(data.code == 0){
                        _self.cart_list[index].stock = stock;
                    }
                    _self.$toast(data.msg)
                })
            },
            to_pay(){
                //暂时不用跳登录页面 2020年9月15日10:12:56
                var user_info = this.getUserInfo(true);
                if(user_info === false){
                    return false;
                }
                if(this.goods_checkbox.length > 0){
                    this.$router.push({path:'/pay',query:{ids:this.goods_checkbox.join(","),buy_type:'cart'}})
                }else{
                    this.$toast('请选择商品')
                }
            },
            del(value,id,index){
                var url = "api/cart/delete";
                var data = {id:id}
                var _self = this;

                this.$dialog.confirm({
                    title: '提示',
                    message: '删除后无法还原，您确定要继续吗？',
                }).then(() => {
                        this.POST(url,data,function (data) {
                            if(data.code == 0){
                                _self.cart_list.splice(index,1);
                                var cart_count = document.getElementById("cart_total").innerText;
                                document.getElementById("cart_total").innerText = Number(cart_count) - 1;
                            }
                        })
                    }).catch(() => {
                        // on cancel
                    });
                return false;

            },
            deleteSelected() {
                var _self = this;
                var url = "api/cart/Delete";
                
                // 修改数据格式
                const data1 = {
                    id: _self.goods_checkbox.join(',')  // 将ID数组转换为逗号分隔的字符串
                };

                console.log('删除数据:', {
                    选中ID: _self.goods_checkbox,
                    发送格式: data1
                });

                this.$dialog.confirm({
                    title: '提示',
                    message: '删除后无法还原，您确定要继续吗？',
                }).then(() => {
                    this.POST(url, data1, function (data) {
                        console.log('删除响应:', data);
                        if(data.code == 0){
                            // 清空购物车列表
                            _self.cart_list = [];
                            // 清空选中状态
                            _self.goods_checkbox = [];
                            // 更新购物车数量显示
                            document.getElementById("cart_total").innerText = "0";
                            // 显示成功提示
                            _self.$toast('删除成功');
                        } else {
                            _self.$toast(data.msg || '删除失败');
                        }
                    });
                }).catch(() => {
                    // 用户取消删除
                    console.log('用户取消删除');
                });
                
                return false;
            }
        },
    }
</script>
<style scoped>
    .wrap {
        background: #f3f3f3;
        min-height: 100vh;
    }
    #cart_box{
        display: none;
    }
    .fixed-carts{
        display: none;
    }
.container_top{margin-top:45px}
.cart-header {
    padding: 15px 20px;
    background: #fff;
    border-bottom: 1px solid #eee;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.cart-title {
    font-size: 18px;
    font-weight: bold;
}

.carts {
    margin-bottom: 0px;
  /* padding: 12px; */
  /* background: #f3f3f3; */
}
.cartsnone{
    margin-bottom: 230px;
}
.cart-item {
  background: #fff;
  margin-bottom: 12px;
  border-radius: 8px;
}

.cart-item-content {
  display: flex;
  gap: 15px;
  padding: 15px;
}

.cart-item-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.cart-item-img {
    width: 97px;
    height: 128px;
    flex-shrink: 0;
}

.cart-item-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  /* border-radius: 4px; */
}

.cart-item-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding-right: 10px;  
}

.cart-item-title {
    max-width: 180px;
    font-size: 16px;
    color: #14142B;
    margin-bottom: 10px;
    font-weight: 500;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    line-clamp: 2;
    margin-right: 15px;
}

.cart-item-spec {
  font-size: 14px;
  color: #14142B;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.spec-item {
    height: 20px;
    line-height: 20px;
    /* margin-bottom: 4px; */
    color: #666;
}

.cart-item-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: auto;
}

.cart-item-price {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.current-price {
  font-size: 18px;
  color: #14142B;
  font-weight: bold;
}

.original-price {
  font-size: 14px;
  color: #999;
  text-decoration: line-through;
}

/* 修改步进器样式 */
:deep(.van-stepper) {
  height: 28px;
}

:deep(.van-stepper__input) {
  background-color: #f5f5f5;
  border-radius: 4px;
}

:deep(.van-stepper__minus),
:deep(.van-stepper__plus) {
  background-color: #f5f5f5;
  border-radius: 4px;
  width: 28px;
}

/* 修改底部结算栏样式 */
.cart-footer {
  /* 移除固定定位 */
  position: static;
  bottom: auto;
  left: auto;
  right: auto;
  padding: 12px 15px;
  background: #f5f7fa;
  display: flex;
  flex-direction: column;
  gap: 12px;
  border-top: 0.001rem solid #ccc;
  margin-top: 20px; /* 添加顶部间距 */
  margin-bottom: -30px;

}

/* 上部分样式 */
.cart-footer-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px;
}

.left-controls {
  display: flex;
  align-items: baseline;
  gap: 15px;
}

.delete-btn {
    font-size: 19px;
  color: #323233;
  cursor: pointer;
  font-weight: bold;
}

.price-info {
  text-align: right;
}

.total-price {
  font-size: 18px;
  font-weight: bold;
  color: #14142B;
}

.discount-price {
  font-size: 12px;
  color: #999;
}

/* 下部分样式 */
.cart-footer-bottom {
  display: flex;
  justify-content: center;
  padding: 0 10px;
}

/* 修改按钮样式 */
.cart-footer-bottom .van-button {
  width: 90%;
  height: 40px;
  background-color: #000000;
  border-color: #000000;
  border-radius: 0;
  font-size: 14px;
}
/* :deep(.van-checkbox){
    margin-top: 1%;
} */
/* 修改复选框样式 */
:deep(.van-checkbox__icon) {
  border-radius: 50%;
}

:deep(.van-checkbox__icon--checked) {
  background-color: #14142B;
  border-color: #14142B;
}
:deep(.van-checkbox__label){
    margin-left: 8px;
    color: #323233;
    font-weight: bold;
    line-height: 29px;
    height: 29px;
}
.cart-empty {
    padding: 60px 0;
}
.youhui{
    width: 49px;
height: 27px;
font-family: Songti SC, Songti SC;
font-weight: bold;
font-size: 12px;
color: #DD8560;
}
.youhui-price{
    width: 44px;
height: 19px;
font-family: Songti SC, Songti SC;
font-weight: 400;
font-size: 16px;
color: #DD8560;
line-height: 19px;
}
.close-btn{
    display: inline-block;
    width: 24px;
    height: 24px;
    line-height: 24px;
    text-align: center;
    font-size: 47px;
    color: #232333;
    cursor: pointer;
    font-weight: lighter;
}
/* 修改全局样式覆盖 */
/* :deep(#nav) {
  background-color: #fff !important;
} */
/* 
:deep(.nav_bj) {
  background-color: #fff !important;
} */
</style>